// extracted by mini-css-extract-plugin
export var colorSquare = "_oh-0";
export var danger = "_oh-5";
export var lightPink = "_oh-8";
export var neutralBlue = "_oh-7";
export var neutralYellow = "_oh-6";
export var normal = "_oh-1";
export var primary = "_oh-2";
export var primaryLight = "_oh-3";
export var solidBlack = "_oh-g";
export var solidGreen = "_oh-b";
export var solidLightBlue = "_oh-d";
export var solidNavy = "_oh-c";
export var solidOrange = "_oh-f";
export var solidPink = "_oh-e";
export var solidRed = "_oh-9";
export var solidYellow = "_oh-a";
export var success = "_oh-4";